import { render, staticRenderFns } from "./follwUpExamStandard.vue?vue&type=template&id=019297cf"
import script from "./follwUpExamStandard.vue?vue&type=script&lang=js"
export * from "./follwUpExamStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019297cf')) {
      api.createRecord('019297cf', component.options)
    } else {
      api.reload('019297cf', component.options)
    }
    module.hot.accept("./follwUpExamStandard.vue?vue&type=template&id=019297cf", function () {
      api.rerender('019297cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/fue/base/follwUpExamStandard.vue"
export default component.exports